import { INoticeModule } from '@/services/notifications/types';

export const defaultModule = {
  icon: '',
  name: '',
  is_show_img: 2,
  id: 0,
  enable: 0,
  display_type: 0,
  disable: false,
  unread_cnt: 0,
  content: '',
  created_at: '',
  module_name: 'all',
};

export const unread = (list: Array<INoticeModule>, id: number, num: number) => {
  if (id === 0) {
    return list.map((item) => {
      return { ...item, unread_cnt: 0 };
    });
  }
  return list.map((item) => {
    if (item.id === id) {
      console.log('searchModule 6', item.id, id, num);
      return { ...item, unread_cnt: num === -1 ? 0 : item.unread_cnt - 1 };
    }
    return item;
  });
};

export const scrollLoad = (loadMessage: () => void) => {
  const windowW = window.innerWidth;

  if (windowW > 767.98) return;

  const scrollTop =
    document.documentElement.scrollTop || document.body.scrollTop;
  const clientHeight =
    document.documentElement.clientHeight || document.body.clientHeight;
  const scrollHeight =
    document.documentElement.scrollHeight || document.body.scrollHeight;
  const numHeight = scrollTop + clientHeight + 550;

  if (scrollHeight > clientHeight && numHeight > scrollHeight) {
    loadMessage();
  }
};
